
interface Identifiable {
    id?: number;
}

interface PossiblyUnsavedIdentifiable {
    id?: number;
    temp_id?: string;
}

export const compareDataAndNoteIds = (notes: PossiblyUnsavedIdentifiable[], data: Identifiable[]) => {
  const noteIds = notes.filter(note => !note.temp_id).map(n => n.id);
  const dataIds = data.map(d => d.id);
  if (noteIds.length !== dataIds.length) {
    return false;
  }
  return noteIds.every(id => dataIds.includes(id));
}